import { render, staticRenderFns } from "./CcCheckBoxGroup.ts.vue?vue&type=template&id=02872792"
import script from "./CcCheckBoxGroup.ts.vue?vue&type=script&lang=ts"
export * from "./CcCheckBoxGroup.ts.vue?vue&type=script&lang=ts"
import style0 from "./CcCheckBoxGroup.ts.vue?vue&type=style&index=0&id=02872792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports